module.exports = __webpack_public_path__ + "static/media/photopaulina.cc81f649.png";